import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard } from '@capacitor/keyboard';
import { App } from '@capacitor/app';

/**
 * Initialize native Capacitor plugins.
 * Call this once in your app's entry point (index.js).
 * Safe to call on web — all calls are no-ops when not running natively.
 */
export async function initNativeApp() {
  if (!Capacitor.isNativePlatform()) return;

  // Dark status bar matching INZARA's #060918 background
  try {
    await StatusBar.setStyle({ style: Style.Dark });
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#060918' });
    }
  } catch {}

  // Hide splash screen after app renders
  try {
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch {}

  // Handle keyboard events on iOS (prevent viewport squish)
  try {
    Keyboard.addListener('keyboardWillShow', () => {
      document.body.classList.add('keyboard-open');
    });
    Keyboard.addListener('keyboardWillHide', () => {
      document.body.classList.remove('keyboard-open');
    });
  } catch {}

  // Handle deep links / app URL open
  try {
    App.addListener('appUrlOpen', (event) => {
      const url = new URL(event.url);
      const path = url.pathname;
      if (path) {
        window.location.hash = '';
        window.history.pushState({}, '', path);
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    });
  } catch {}

  // Handle back button on Android
  try {
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
  } catch {}
}

/**
 * Check if running as a native app.
 */
export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

/**
 * Get the current platform.
 */
export function getPlatform() {
  return Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
}
